@if (innerHTML()) {
    <p
        [id]="id() + '-text'"
        [class.long-text]="true"
        [class.overflow]="maxHeight() !== undefined"
        [style.max-height]="maxHeight() ? maxHeight() : 'unset'"
        [innerHTML]="text() || '-' | translate"></p>
} @else {
    <p
        [id]="id() + '-text'"
        [class.long-text]="true"
        [class.overflow]="maxHeight() !== undefined"
        [style.max-height]="maxHeight() ? maxHeight() : 'unset'">
        <span>{{ text() || '-' | translate }}</span>
    </p>
}
